var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.61195C5.51543 7.61195 5.03086 7.37297 4.66397 6.90384L0.150562 1.13272C-0.0501875 0.87603 -0.0501875 0.451162 0.150562 0.194471C0.351312 -0.0622196 0.683588 -0.0622196 0.884338 0.194471L5.39775 5.96559C5.73003 6.39046 6.26997 6.39046 6.60225 5.96559L11.1157 0.194471C11.3164 -0.0622196 11.6487 -0.0622196 11.8494 0.194471C12.0502 0.451162 12.0502 0.87603 11.8494 1.13272L7.33603 6.90384C6.96914 7.37297 6.48457 7.61195 6 7.61195Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.43647cd01a8e7ab2e02381254aa4486f.svg";
export { ForwardRef as ReactComponent };